/* src/app/views/landing/landing.component.css */
#blackOverlay {
  background: linear-gradient(#1a77678f, #8de2c1b5);
}
.border-user-type-card {
  border: 1px dashed #1e293b;
}
.w-22-p {
  width: 22% !important;
}
.doctor-custom-card {
  background:
    linear-gradient(
      101.96deg,
      #156858 3.17%,
      #39CABB 133.01%);
}
.carousel-section {
}
.carousel-container {
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}
.carousel-header {
  direction: ltr;
  display: flex;
  justify-content: start;
  align-items: center;
}
.carousel-controls {
  display: flex;
}
.carousel-btn {
  padding: 10px;
  margin: 20px;
  font-size: 1.5rem;
}
.carousel-wrapper {
  display: flex;
  transition: transform 0.5s ease;
  width: 100%;
  transform: translateX(0);
}
.carousel-slide {
  display: flex;
  min-width: 33.33%;
  justify-content: space-around;
}
.card {
  flex: 1;
  padding: 28px 0px;
  margin: 0 10px;
  border-radius: 4px;
  display: grid;
  align-content: space-around;
}
.card img {
  width: 100%;
  height: auto;
}
@media (max-width:762px) {
  .carousel-slide {
    min-width: 50% !important;
  }
}
/*# sourceMappingURL=landing.component.css.map */
